import React, { useState, useEffect } from 'react'
import Plot from 'react-plotly.js'
import { Select } from 'antd'
import axios from 'axios'
import { useSelectedWeek } from '../../../../../../contexts/SelectedWeekContext'
import { computeSelectedWeekForSeason, getWeekFromWeek, getYearFromWeek, SeasonRange, seasonReferenceYear } from '../../../../../../../_metronic/helpers'

const { Option } = Select
interface DataItem {
  week: string
  diagnosisCategory: string
  nDeathNowcast: number | null
  lowerCiBaselineNDeath: number | null
  upperCiBaselineNDeath: number | null
}
interface AvergeDataItem {
  week: string
  percent: string
}
interface Trace {
  x: string[]
  y: (number | null)[]
  type: string
  mode: string
  marker?: { color: string }
  line?: { color: string }
  yaxis?: string
  name: string
  hovertemplate: any | null
}
interface StreamgraphChartProps {
  season: SeasonRange
  selectedDiagnosisCategories: string[]
  setSelectedDiagnosisCategories: (v: any) => void
}
const StreamgraphChart: React.FC<StreamgraphChartProps> = ({ season, selectedDiagnosisCategories, setSelectedDiagnosisCategories }) => {
  const { selectedWeek, setSelectedWeek } = useSelectedWeek('2025-W40')
  const API_URL = process.env.REACT_APP_API_URL
  const [plotData, setPlotData] = useState<Trace[]>([])
  // const [selectedDiagnosisCategories, setSelectedDiagnosisCategories] = useState<string[]>([
  //   'trace5',
  // ])
  const [missingData, setMissingData] = useState<DataItem[]>([])
  const [avergeData, setAvergeData] = useState<AvergeDataItem[]>([])
  const [plotUpdateData, setPlotUpdateData] = useState<Trace[]>([])
  const [showArrow, setShowArrow] = useState<boolean>(false)

  const [seasonSelectedWeek, setSeasonSelectedWeek] = useState<string | null>(null)
  const startYear = getYearFromWeek(season.startWeek)
  const endYear = getYearFromWeek(season.endWeek)
  const startWeekNumber = getWeekFromWeek(season.startWeek) + 1

  function addMissingWeek(data: DataItem[]): DataItem[] {
    const startWeek = season.startWeek // First week in the data
    const endWeek = season.endWeek // Last week in the data
    const existingWeeks = new Set(data.map((item) => item.week)) // Set to store existing weeks
    const newData: DataItem[] = []

    let currentWeek = startWeek

    while (currentWeek !== endWeek) {
      // Move to the next week
      const [year, weekNum] = currentWeek.split('-W')
      const weekNumber = parseInt(weekNum)
      if (weekNumber < 52) {
        currentWeek = `${year}-W${(weekNumber + 1).toString()}`
      } else {
        currentWeek = `${parseInt(year) + 1}-W1`
      }
      if (!existingWeeks.has(currentWeek)) {

        newData.push({
          week: currentWeek,
          upperCiBaselineNDeath: null,
          lowerCiBaselineNDeath: null,
          nDeathNowcast: null,
          diagnosisCategory: 'COVID-19',
        })
        newData.push({
          week: currentWeek,
          upperCiBaselineNDeath: null,
          lowerCiBaselineNDeath: null,
          nDeathNowcast: null,
          diagnosisCategory: 'FLU',
        })
        newData.push({
          week: currentWeek,
          upperCiBaselineNDeath: null,
          lowerCiBaselineNDeath: null,
          nDeathNowcast: null,
          diagnosisCategory: 'RSV',
        })
        newData.push({
          week: currentWeek,
          upperCiBaselineNDeath: null,
          lowerCiBaselineNDeath: null,
          nDeathNowcast: null,
          diagnosisCategory: 'IR AUTVIRUS',
        })
        newData.push({
          week: currentWeek,
          upperCiBaselineNDeath: null,
          lowerCiBaselineNDeath: null,
          nDeathNowcast: null,
          diagnosisCategory: 'all_resp_diags',
        })
      }

    }

    // Find the index to insert the new week
    let insertionIndex = 0
    for (let i = 0; i < data.length; i++) {
      if (data[i].week <= `${startYear}-W52`) {
        insertionIndex = i + 1
      } else {
        break
      }
    }
    // Merge existing data with the newly added missing weeks
    const mergedData = [
      ...data.slice(0, insertionIndex),
      ...newData,
      ...data.slice(insertionIndex),
    ].sort((a, b) => {
      const aYear = parseInt(a.week.substring(0, 4), 10)
      const aWeek = parseInt(a.week.substring(a.week.indexOf('-W') + 2), 10)
      const bYear = parseInt(b.week.substring(0, 4), 10)
      const bWeek = parseInt(b.week.substring(b.week.indexOf('-W') + 2), 10)
      if (aYear !== bYear) {
        return aYear - bYear
      } else {
        return aWeek - bWeek
      }
    })
    return mergedData
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL + `/RespiratorySyndromesDiagnosisDeaths`)
        const uniqueWeeks: string[] = []
        const responseData = addMissingWeek(response.data).filter((entry) => {
          const currentYear = parseInt(entry.week.substring(0, 4), 10)
          const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
          // return (currentYear === 2025 && currentWeek >= 36) || currentYear > 2025
          return (
            (currentYear === startYear && currentWeek >= startWeekNumber) ||
            (currentYear === endYear && currentWeek <= 27) ||
            (currentYear > startYear && currentYear < endYear)
          );
        })


        for (const entry of responseData) {
          if (!uniqueWeeks.includes(entry.week)) {
            uniqueWeeks.push(entry.week)
          }
        }

        // Initialize an array to store aggregated DataItem objects for each week
        // const aggregatedData: DataItem[] = []

        // // Iterate over each unique week
        // for (const week of uniqueWeeks) {
        //   // Filter data for the current week and sum their percentNowcast values
        //   const weekData = responseData.filter((entry) => entry.week === week)
        //   const weekSum = weekData.reduce((sum, entry) => sum + ((entry.diagnosisCategory !== 'IR GENERALE') ? entry.nDeathNowcast : 0), 0);
        //   const weekSumUpper = weekData.reduce((sum, entry) => sum + ((entry.diagnosisCategory !== 'IR GENERALE') ? Number(entry.upperCiBaselineNDeath) : 0), 0);
        //   const weekSumLower = weekData.reduce((sum, entry) => sum + ((entry.diagnosisCategory !== 'IR GENERALE') ? Number(entry.lowerCiBaselineNDeath) : 0), 0);

        //   // Create a new DataItem object for the current week with the sum of percentNowcast
        //   const weekDataItem: DataItem = {
        //     week: week,
        //     diagnosisCategory: 'all',
        //     nDeathNowcast: weekSum,
        //     lowerCiBaselineNDeath: weekSumLower,
        //     upperCiBaselineNDeath: weekSumUpper,
        //   }

        //   // Push the DataItem object to the aggregatedData array
        //   aggregatedData.push(weekDataItem)
        // }
        const allVirusData = responseData.filter((entry: DataItem) => {
          const currentYear = parseInt(entry.week.substring(0, 4), 10)
          const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
          return (
            (currentYear === startYear && currentWeek >= startWeekNumber && entry.diagnosisCategory === 'all_resp_diags') ||
            (currentYear > startYear && entry.diagnosisCategory === 'all_resp_diags')
          )
        })
        const covidData = responseData.filter((entry: DataItem) => {
          const currentYear = parseInt(entry.week.substring(0, 4), 10)
          const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
          return (
            (currentYear === startYear && currentWeek >= startWeekNumber && entry.diagnosisCategory === 'COVID-19') ||
            (currentYear > startYear && entry.diagnosisCategory === 'COVID-19')
          )
        })

        const otherVirusData = responseData.filter((entry: DataItem) => {
          const currentYear = parseInt(entry.week.substring(0, 4), 10)
          const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
          return (
            (currentYear === startYear &&
              currentWeek >= startWeekNumber &&
              entry.diagnosisCategory === 'IR AUTVIRUS') ||
            (currentYear > startYear && entry.diagnosisCategory === 'IR AUTVIRUS')
          )
        })

        const rsvData = responseData.filter((entry: DataItem) => {
          const currentYear = parseInt(entry.week.substring(0, 4), 10)
          const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
          return (
            (currentYear === startYear && currentWeek >= startWeekNumber && entry.diagnosisCategory === 'RSV') ||
            (currentYear > startYear && entry.diagnosisCategory === 'RSV')
          )
        })
        const fluData = responseData.filter((entry: DataItem) => {
          const currentYear = parseInt(entry.week.substring(0, 4), 10)
          const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
          return (
            (currentYear === startYear && currentWeek >= startWeekNumber && entry.diagnosisCategory === 'FLU') ||
            (currentYear > startYear && entry.diagnosisCategory === 'FLU')
          )
        })
        // const generaleData = response.data.filter((entry: DataItem) => {
        //   const currentYear = parseInt(entry.week.substring(0, 4), 10)
        //   const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
        //   return (
        //     (currentYear === 2023 &&
        //       currentWeek >= 35 &&
        //       entry.diagnosisCategory === 'IR GENERALE') ||
        //     (currentYear > 2023 && entry.diagnosisCategory === 'IR GENERALE')
        //   )
        // })

        let endWeek = season?.endWeek?.split('-W')
        const alignedWeek =
          startYear == seasonReferenceYear
            ? selectedWeek
            : computeSelectedWeekForSeason(selectedWeek, season.startWeek)
        const selectWeek = alignedWeek.split('-W')
        const showArrow =
          (Number(selectWeek[0]) > startYear ||
            (Number(selectWeek[0]) === startYear && Number(selectWeek[1]) >= startWeekNumber)) &&
          (Number(selectWeek[0]) < Number(endWeek[0]) ||
            (Number(selectWeek[0]) === Number(endWeek[0]) &&
              Number(selectWeek[1]) <= Number(endWeek[1])))
        setShowArrow(showArrow)
        setSeasonSelectedWeek(alignedWeek);

        const trace2 = {
          x: covidData.map((entry) => entry.week),
          y: covidData.map((entry) => entry.nDeathNowcast),
          type: 'scatter',
          yaxis: 'y',
          mode: 'lines',
          marker: { color: '#6610f2' },
          name: 'number of deaths for respiratory syndromes - SARS-CoV-2',
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }

        const trace4 = {
          x: otherVirusData.map((entry) => entry.week),
          y: otherVirusData.map((entry) => entry.nDeathNowcast),
          type: 'scatter',
          yaxis: 'y',
          mode: 'lines',
          line: { color: '#792075' },
          name: 'number of deaths for respiratory syndromes - Other respiratory infections',
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }
        const trace3 = {
          x: rsvData.map((entry) => entry.week),
          y: rsvData.map((entry) => entry.nDeathNowcast),
          type: 'scatter',
          yaxis: 'y',
          mode: 'lines',
          marker: { color: '#0d6efd' },
          name: 'number of deaths for respiratory syndromes - RSV',
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }

        const trace1 = {
          x: fluData.map((entry) => entry.week),
          y: fluData.map((entry) => entry.nDeathNowcast),
          type: 'scatter',
          yaxis: 'y',
          mode: 'lines',
          line: { color: '#00d9d9' },
          name: 'number of deaths for respiratory syndromes - Influenza',
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }
        const trace5 = {
          x: allVirusData.map((entry) => entry.week),
          y: allVirusData.map((entry) => entry.nDeathNowcast),
          type: 'scatter',
          yaxis: 'y',
          mode: 'lines',
          line: { color: '#203879' },
          name: 'number of deaths for respiratory syndromes - All Virus',
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }
        const tracemin = {
          x: allVirusData
            .filter((entry) => {
              const currentYear = parseInt(entry.week.substring(0, 4), 10)
              const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
              // return (currentYear === 2025 && currentWeek >= 35) || currentYear > 2025
              return (
                (currentYear === startYear && currentWeek >= startWeekNumber) ||
                (currentYear === endYear && currentWeek <= 27) ||
                (currentYear > startYear && currentYear < endYear)
              );
            })
            .map((entry) => entry.week),
          y: allVirusData
            .filter((entry) => {
              const currentYear = parseInt(entry.week.substring(0, 4), 10)
              const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
              // return (currentYear === 2025 && currentWeek >= 35) || currentYear > 2025
              return (
                (currentYear === startYear && currentWeek >= startWeekNumber) ||
                (currentYear === endYear && currentWeek <= 27) ||
                (currentYear > startYear && currentYear < endYear)
              );
            })
            .map((entry) => entry.lowerCiBaselineNDeath),

          type: 'scatter',
          mode: 'lines',

          line: { color: 'lightgrey', dash: 'dashdot' },
          name: 'min all ages',
          showlegend: false,
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }

        const tracemax = {
          x: allVirusData
            .filter((entry) => {
              const currentYear = parseInt(entry.week.substring(0, 4), 10)
              const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
              // return (currentYear === 2025 && currentWeek >= 36) || currentYear > 2025
              return (
                (currentYear === startYear && currentWeek >= startWeekNumber) ||
                (currentYear === endYear && currentWeek <= 27) ||
                (currentYear > startYear && currentYear < endYear)
              );
            })
            .map((entry) => entry.week),
          y: allVirusData
            .filter((entry) => {
              const currentYear = parseInt(entry.week.substring(0, 4), 10)
              const currentWeek = parseInt(entry.week.substring(entry.week.indexOf('-W') + 2), 10)
              // return (currentYear === 2025 && currentWeek >= 36) || currentYear > 2025
              return (
                (currentYear === startYear && currentWeek >= startWeekNumber) ||
                (currentYear === endYear && currentWeek <= 27) ||
                (currentYear > startYear && currentYear < endYear)
              );
            })
            .map((entry) => entry.upperCiBaselineNDeath),

          type: 'scatter',
          fill: 'tonexty',
          mode: 'lines',
          line: { color: '#BBBBBC', dash: 'dashdot' },
          name: 'Statistical range of normal percentage*',
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }

        const startWeek = season.startWeek // First week in the data
        const endWeek0 = season.endWeek // Last week in the data
        const existingWeeks = new Set(response.data.map((item) => item.week)) // Set to store existing weeks

        const missingData: DataItem[] = []
        let currentWeek = startWeek
        while (currentWeek !== endWeek0) {
          // Move to the next week
          const [year, weekNum] = currentWeek.split('-W')
          const weekNumber = parseInt(weekNum)
          if (weekNumber < 52) {
            currentWeek = `${year}-W${(weekNumber + 1).toString()}`
          } else {
            currentWeek = `${parseInt(year) + 1}-W1`
          }
          if (!existingWeeks.has(currentWeek)) {
            missingData.push({
              week: currentWeek,
              upperCiBaselineNDeath: null,
              lowerCiBaselineNDeath: null,
              nDeathNowcast: null,
              diagnosisCategory: '',
            })
          }
        }

        const missdata = {
          x: missingData.map((entry) => entry.week),
          y: missingData.map((entry) => 0),
          type: 'scatter',
          mode: 'markers',
          yaxis: 'y',
          name: 'Missing Data',
          marker: { color: '#000000' },
          hovertemplate:
            '<b>%{fullData.name}</b><br>' +
            'Week: %{x}<br>' +
            '%{fullData.name}: %{y}<extra></extra>',
        }
        // const avergefetchData = async () => {
        //   try {
        //     const avergeResponse = await axios.get(
        //       API_URL + `/RespiratorySyndromesDiagnosisDeaths/averge`
        //     )

        //     setAvergeData(
        //       avergeResponse.data.filter((entry) => {
        //         const currentWeek = parseInt(entry.substring(entry.indexOf('-W') + 2), 10)
        //         const targetWeek = parseInt('2023-W35'.substring('2023-W35'.indexOf('-W') + 2), 10)
        //         return currentWeek >= targetWeek
        //       })
        //     )
        //   } catch (error) {
        //     console.error('Error fetching data:', error)
        //     // Handle error or set a default value for data
        //   }
        // }
        // const averge = {
        //   x: avergeData.map((entry) => entry.week),
        //   y: avergeData.map((entry) => parseFloat(entry.percent)),
        //   type: 'scatter',
        //   yaxis: 'y2',
        //   mode: 'lines',
        //   line: {color: '#ed7d31'},
        //   name: 'Cases',
        // }

        setPlotData([tracemin, tracemax, trace1, trace2, trace3, trace4, trace5, missdata])
        let updatedPlotData: Trace[] = []
        if (
          selectedDiagnosisCategories.includes('trace5') &&
          selectedDiagnosisCategories.length <= 1
        ) {
          updatedPlotData.push(tracemin)
          updatedPlotData.push(tracemax)
        }

        if (selectedDiagnosisCategories.includes('trace1')) {
          updatedPlotData.push(trace1)
        }
        if (selectedDiagnosisCategories.includes('trace2')) {
          updatedPlotData.push(trace2)
        }
        if (selectedDiagnosisCategories.includes('trace3')) {
          updatedPlotData.push(trace3)
        }
        if (selectedDiagnosisCategories.includes('trace4')) {
          updatedPlotData.push(trace4)
        }
        if (selectedDiagnosisCategories.includes('trace5')) {
          updatedPlotData.push(trace5)
        }
        updatedPlotData.push(missdata)


        setPlotUpdateData(updatedPlotData)

        // setDataGenerale(generaleData)
      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data

      }
    }


    fetchData()
    //avergefetchData()
  }, [selectedWeek, selectedDiagnosisCategories])



  // const trace6 = {
  //   x: avergeData.map((entry) => entry.week),
  //   y: avergeData.map((entry) => entry.percent),
  //   type: 'scatter',
  //   yaxis: 'y2',
  //   mode: 'lines',
  //   line: {color: '#ffc700'},
  //   name: '% Cases',
  // }

  // const plotData = [trace1, trace2, trace3, trace4]

  const layout = {
    title: `Number of deaths of patients with a diagnosis of respiratory syndromes`,
    barmode: 'stack',
    bargap: 0.2, // Adjust the gap between bars
    bargroupgap: 0.1, // Adjust the gap between bar groups
    autosize: true,

    annotations: [
      {
        xref: 'paper',
        yref: 'paper',
        x: -0.035,
        xanchor: 'right',
        y: 0.5,
        yanchor: 'bottom',
        text: '#',
        font: {
          size: 25,

          //color: '#BBBBBC',
        },
        showarrow: false,
      },
      {
        x: startYear == 2025 ? selectedWeek : seasonSelectedWeek,
        y: 0,
        xref: 'x',
        yref: 'y',
        text: showArrow ? 'Selected Week' : '',
        font: {
          family: 'Courier New, monospace',
          size: 16,
          color: '#CC1B1B',
        },
        arrowcolor: '#CC1B1B',
        showarrow: showArrow,
        arrowhead: 7,
        ax: 0,
        ay: -170,
      },
      // {
      //   xref: 'paper',
      //   yref: 'paper',
      //   x: 1.01,
      //   xanchor: 'left',
      //   y: 0.5,
      //   yanchor: 'bottom',
      //   text: 'min-max',
      //   font: {
      //     size: 12,

      //     color: '#BBBBBC',
      //   },
      //   showarrow: false,
      // },
    ],

    xaxis: {
      title: 'Weeks',
      autorange: true,
      type: 'category',
      tickangle: -45,
    },
    yaxis: {
      // autorange: false,
      range: [0, null],
    },
    yaxis2: {
      showgrid: false,
      titlefont: { color: 'rgb(148, 103, 189)' },
      tickfont: { color: 'rgb(148, 103, 189)' },
      overlaying: 'y',
      side: 'right',
    },
    legend: {
      x: 0,
      y: -0.5,
      orientation: 'h',
    },
  }

  const handleDataChangeVirus = async (values: string[]) => {
    if (values.length === 0) {
      setSelectedDiagnosisCategories(['trace5']);
    } else {
      setSelectedDiagnosisCategories(values)

      let updatedPlotData: Trace[] = []
      if (values.includes('trace5') && values.length <= 1) {
        updatedPlotData.push(plotData[0])
        updatedPlotData.push(plotData[1])
      }
      if (values.includes('trace1')) {
        updatedPlotData.push(plotData[2])
      }
      if (values.includes('trace2')) {
        updatedPlotData.push(plotData[3])
      }
      if (values.includes('trace3')) {
        updatedPlotData.push(plotData[4])
      }
      if (values.includes('trace4')) {
        updatedPlotData.push(plotData[5])
      }
      if (values.includes('trace5')) {
        updatedPlotData.push(plotData[6])
      }
      updatedPlotData.push(plotData[7])
      setPlotUpdateData(updatedPlotData)
    }
  }

  return (
    <>
      <div className='row mt-2'>
        <label style={{ width: '10%' }} className='col-1 mt-3 text-primary fw-medium fs-5'>
          Virus :
        </label>
        <div className='col-6'>
          <Select
            mode='multiple'
            variant='borderless'
            className='border border-gray-500 border-3 rounded'
            style={{ width: '72.5%' }}
            size='large'
            value={selectedDiagnosisCategories}
            onChange={(value, option) => handleDataChangeVirus(value)}
          >
            <Option key={'trace5'} value={'trace5'}>
              {'All virus'}
            </Option>
            <Option key={'trace1'} value={'trace1'}>
              {'Influenza'}
            </Option>
            <Option key={'trace2'} value={'trace2'}>
              {'SARS-CoV-2'}
            </Option>
            <Option key={'trace3'} value={'trace3'}>
              {'RSV'}
            </Option>
            <Option key={'trace4'} value={'trace4'}>
              {'Other respiratory infections'}
            </Option>
          </Select>
        </div>
      </div>
      <div className='plotContainer'>
        <Plot
          style={{ width: '100%', height: '400px' }}
          data={plotUpdateData}
          layout={layout}
          config={{
            displaylogo: false,
            responsive: true,
          }}
        />
      </div>
    </>
  )
}

export default StreamgraphChart
